import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

// Import images
import img1 from "../../img/10276.jpg";
import img2 from "../../img/16522.jpg";
import img3 from "../../img/2150010142.jpg";

export default function CSS_MQExamples() {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">
        📱 CSS Media Queries: Basic to Advanced Examples
      </h1>

      <p className="tutorial-intro">
        Learn how to use CSS Media Queries for responsive design, starting from
        basic text and layout adjustments to advanced components like navbar,
        image card, gallery, and form.
      </p>

      {/* SECTION 1: Basic Text Adjustment */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Basic Text Resize</h2>
        <CodeCopyBlock
          code={`p {
  font-size: 18px;
}
@media (max-width: 600px) {
  p {
    font-size: 14px;
  }
}`}
        />
        <p style={{ fontSize: "18px", marginBottom: "1rem" }}>
          This paragraph uses a media query to reduce font size on small
          screens.
        </p>
      </div>

      {/* SECTION 2: Basic Layout */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Basic Layout with Flex</h2>
        <CodeCopyBlock
          code={`.container {
  display: flex;
  gap: 20px;
}
@media (max-width: 700px) {
  .container {
    flex-direction: column;
  }
}`}
        />
        <div
          className="container"
          style={{ display: "flex", gap: "20px", marginBottom: "1rem" }}
        >
          <div
            style={{
              flex: 1,
              background: "#3b82f6",
              color: "white",
              padding: "10px",
            }}
          >
            Box 1
          </div>
          <div
            style={{
              flex: 1,
              background: "#9333ea",
              color: "white",
              padding: "10px",
            }}
          >
            Box 2
          </div>
        </div>
      </div>

      {/* SECTION 3: Responsive Navbar */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Responsive Navbar</h2>
        <CodeCopyBlock
          code={`.navbar {
  display: flex;
  justify-content: space-between;
  background: #3b82f6;
  padding: 10px 20px;
  border-radius: 8px;
  color: white;
}
.nav-links {
  display: flex;
  gap: 15px;
}
@media (max-width: 600px) {
  .nav-links {
    flex-direction: column;
    gap: 10px;
  }
}`}
        />
        <div
          className="navbar"
          style={{
            display: "flex",
            justifyContent: "space-between",
            background: "#3b82f6",
            padding: "10px 20px",
            borderRadius: "8px",
            color: "white",
            marginBottom: "1rem",
          }}
        >
          <span>Logo</span>
          <div
            className="nav-links"
            style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}
          >
            <a href="#" style={{ color: "white" }}>
              Home
            </a>
            <a href="#" style={{ color: "white" }}>
              About
            </a>
            <a href="#" style={{ color: "white" }}>
              Services
            </a>
            <a href="#" style={{ color: "white" }}>
              Contact
            </a>
          </div>
        </div>
      </div>

      {/* SECTION 4: Image Card */}
      <div className="tutorial-section">
        <h2 className="section-title">4️⃣ Responsive Image Card</h2>
        <CodeCopyBlock
          code={`.card {
  max-width: 300px;
  border: 2px solid #9333ea;
  border-radius: 12px;
  overflow: hidden;
}
.card img {
  width: 100%;
  display: block;
}
.card-content {
  padding: 15px;
}
@media (max-width: 500px) {
  .card {
    max-width: 100%;
  }
}`}
        />
        <div
          className="card"
          style={{
            maxWidth: "300px",
            border: "2px solid #9333ea",
            borderRadius: "12px",
            overflow: "hidden",
            marginBottom: "1rem",
          }}
        >
          <img src={img1} alt="Card" style={{ width: "100%" }} />
          <div className="card-content" style={{ padding: "15px" }}>
            <h3>Card Title</h3>
            <p>Responsive image card example.</p>
          </div>
        </div>
      </div>

      {/* SECTION 5: Image Gallery */}
      <div className="tutorial-section">
        <h2 className="section-title">5️⃣ Responsive Image Gallery</h2>
        <CodeCopyBlock
          code={`.gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
@media (max-width: 800px) {
  .gallery {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 500px) {
  .gallery {
    grid-template-columns: 1fr;
  }
}`}
        />
        <div
          className="gallery"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "10px",
            marginBottom: "1rem",
          }}
        >
          <img src={img1} alt="Gallery 1" style={{ width: "100%" }} />
          <img src={img2} alt="Gallery 2" style={{ width: "100%" }} />
          <img src={img3} alt="Gallery 3" style={{ width: "100%" }} />
          <img src={img1} alt="Gallery 4" style={{ width: "100%" }} />
          <img src={img2} alt="Gallery 5" style={{ width: "100%" }} />
          <img src={img3} alt="Gallery 6" style={{ width: "100%" }} />
        </div>
      </div>

      {/* SECTION 6: Responsive Form */}
      <div className="tutorial-section">
        <h2 className="section-title">6️⃣ Responsive Form</h2>
        <CodeCopyBlock
          code={`.form-container {
  max-width: 400px;
  padding: 20px;
  border: 2px solid #f97316;
  border-radius: 12px;
}
.form-container input,
.form-container textarea,
.form-container button {
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
}
@media (max-width: 500px) {
  .form-container {
    padding: 15px;
  }
}`}
        />
        <form
          className="form-container"
          style={{
            maxWidth: "400px",
            padding: "20px",
            border: "2px solid #f97316",
            borderRadius: "12px",
            marginBottom: "2rem",
          }}
        >
          <input
            type="text"
            placeholder="Name"
            style={{ width: "100%", marginBottom: "10px", padding: "10px" }}
          />
          <input
            type="email"
            placeholder="Email"
            style={{ width: "100%", marginBottom: "10px", padding: "10px" }}
          />
          <textarea
            placeholder="Message"
            style={{ width: "100%", marginBottom: "10px", padding: "10px" }}
          />
          <button
            style={{
              width: "100%",
              padding: "10px",
              background: "#f97316",
              color: "white",
              border: "none",
              borderRadius: "6px",
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
